import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";
import { route } from "preact-router";
import { Box } from "@mui/system";

export default function DeleteDealRealEstateDialog(props) {
	const [form, setForm] = useState({ confirm: "" });
	const [disabled, setDisabled] = useState(true);
	const handleClose = () => {
		props.onClose();
	};
	const handleChange = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value });
	};

	useEffect(() => {
		//console.log(form.confirm, (form.confirm === "supprimer " + state.name))
		setDisabled(!(form.confirm === "supprimer " + props.state.params.name));
	}, [form]);
	const handleSubmitDeleteDealUser = () => {
		//console.log("handleSubmitDeleteDealUser", state);
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/998f31e1295c4f28a60b06180a409513/" + props.state.params.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						if (props.state.params.mode == "AM") {
							window.location.reload(); // href = "/newdeala/" + props.state.params.uid + "/0";
						}
						if (props.state.params.mode == "VN") {
							window.location.reload(); // = "/newdealv/" + props.state.params.uid + "/0";
						}
						//window.location.replace("/newdealv/" + res.id+"/0");
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	return (
		<Dialog aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">Suppression d'un bien</DialogTitle>
			<DialogContent dividers>
				<Typography variant="h5" gutterBottom>
					Vous souhaitez supprimer ce bien ?
				</Typography>
			</DialogContent>

			<DialogActions>
				<Box display="flex" justifyContent={"space-between"} alignItems="center" style="width: 100%">
					<Box p={1}>	<Button variant="contained" onClick={handleClose}>
						Annuler
					</Button></Box>
					<Box p={1}><Button
						variant="contained"
						onClick={handleSubmitDeleteDealUser}
						//style="margin: 10px;"
						disabled={false}
					>
						Supprimer
					</Button></Box>
				</Box>


			</DialogActions>
		</Dialog>
	);
}
